// components/MyPage/components/Sidebar.js
import React from "react";
import styled from "styled-components";
import { User, Lock, Bell, Moon, LogOut, Upload, BarChart } from "lucide-react";

const SidebarContainer = styled.div`
  background-color: white;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
`

const SidebarHeader = styled.div`
  padding: 20px;
  border-bottom: 1px solid #eee;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Avatar = styled.div`
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background-color: #eee;
  margin-bottom: 12px;
  overflow: hidden;
  position: relative;
  
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  
  .avatar-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    opacity: 0;
    transition: opacity 0.2s;
    cursor: pointer;
  }
  
  &:hover .avatar-overlay {
    opacity: 1;
  }
`;

const AvatarUploadInput = styled.input`
  display: none;
`;

const UserName = styled.div`
  font-weight: 600;
  font-size: 16px;
`;

const UserEmail = styled.div`
  color: #666;
  font-size: 14px;
`;

const SidebarMenu = styled.div`
  padding: 12px 0;
`;

const MenuItem = styled.button`
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 12px 20px;
  background-color: ${(props) => (props.$active ? "#f5f5f5" : "transparent")};
  border: none;
  text-align: left;
  cursor: pointer;
  
  &:hover {
    background-color: #f5f5f5;
  }
  
  .icon {
    color: ${(props) => (props.$active ? "#2563eb" : "#666")};
  }
  
  .text {
    color: ${(props) => (props.$active ? "#2563eb" : "#333")};
    font-weight: ${(props) => (props.$active ? "600" : "400")};
  }
`;

const Sidebar = ({ 
  activeSection, 
  setActiveSection, 
  formData, 
  fileInputRef, 
  avatarPreview, 
  handleAvatarClick, 
  handleFileChange, 
  handleLogout 
}) => {
  return (
    <SidebarContainer>
      <SidebarHeader>
        <Avatar>
          <img 
            src={avatarPreview || formData.avatar_url || "/resource/defaultImg.png?height=80&width=80"} 
            alt="User avatar" 
          />
          <div className="avatar-overlay" onClick={handleAvatarClick}>
            <Upload size={20} color="white" />
          </div>
          <AvatarUploadInput
            ref={fileInputRef}
            type="file"
            accept="image/*"
            onChange={handleFileChange}
          />
        </Avatar>
        <UserName>{formData.username}</UserName>
        <UserEmail>{formData.email}</UserEmail>
      </SidebarHeader>
      <SidebarMenu>
        <MenuItem $active={activeSection === "dashboard"} onClick={() => setActiveSection("dashboard")}>
          <BarChart size={18} className="icon" />
          <span className="text">대시보드</span>
        </MenuItem>
        <MenuItem $active={activeSection === "profile"} onClick={() => setActiveSection("profile")}>
          <User size={18} className="icon" />
          <span className="text">프로필</span>
        </MenuItem>
        <MenuItem $active={activeSection === "security"} onClick={() => setActiveSection("security")}>
          <Lock size={18} className="icon" />
          <span className="text">보안</span>
        </MenuItem>
        <MenuItem $active={activeSection === "notifications"} onClick={() => setActiveSection("notifications")}>
          <Bell size={18} className="icon" />
          <span className="text">알림</span>
        </MenuItem>
        <MenuItem $active={activeSection === "appearance"} onClick={() => setActiveSection("appearance")}>
          <Moon size={18} className="icon" />
          <span className="text">화면</span>
        </MenuItem>
      </SidebarMenu>
      <SidebarMenu>
        <MenuItem onClick={handleLogout}>
          <LogOut size={18} className="icon" style={{ color: "#ef4444" }} />
          <span className="text" style={{ color: "#ef4444" }}>
            로그아웃
          </span>
        </MenuItem>
      </SidebarMenu>
    </SidebarContainer>
  );
};

export default Sidebar;